import SecondaryButton from './SecondaryButton.js';

export default SecondaryButton;
